<style scoped>
.el-col-5 {
  width: 30%;
}
.chooseBox {
  display: flex;
  /* justify-content: center; */
  /* margin-top: 30px; */
}
.upload-txt {
  line-height: 6px;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
.txt-color{
  text-decoration: none;
}
.clear-person{
  color: #4fa1a4;
  float: right;
  margin-right: 20px;
  text-decoration: underline;
  cursor: pointer;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">公司名称</div>
          <el-select size="mini" v-model="page.tenantName" filterable placeholder="请选择所属公司" class="ipt-sty w70f">
              <el-option 
              v-for="item in approvalerList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">资料名称</div>
          <el-input size="mini" v-model="page.fileName" class="ipt-sty" placeholder="请输入资料名称"></el-input>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="add(1, '')">上传资料</el-button>
        <el-button size="mini" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
      </div>
      <el-table
        :data="tableData"
        @selection-change="handleSelectionChange1"
        :height="tableHeight" stripe border
        v-loading="tableWrapLoading"
        style="width: 100%"
      >
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="tenantName"
          label="所属公司"
          min-width="240"
          header-align="center"
          align="left"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="fileName"
          min-width="240"
          label="资料名称"
          header-align="center"
          show-overflow-tooltip 
          align="left"
        ></el-table-column>
        <el-table-column
          prop="fileDesc"
          label="资料描述"
          min-width="140"
          header-align="center"
          show-overflow-tooltip
          align="left"
        >
          <template slot-scope="scope">{{ scope.row.fileDesc || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="staffNames"
          label="可用人员"
          width="140"
          header-align="center"
          align="left"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.staffNames || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="downloadNum"
          label="资料下载次数"
          header-align="center"
          align="right"
          width="110"
        >
          <template slot-scope="scope">{{ scope.row.downloadNum || 0 }}</template>
        </el-table-column>
        <el-table-column prop="uploadTime" label="上传时间" width="170" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.uploadTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="130">
          <template slot-scope="scope">
            <a class="txt-color" @click="downFile(scope.row)">下载 | </a>
            <!-- <a class="txt-color" :href="scope.row.attach | fileUrl" :download="scope.row.attach | fileName">下载 | </a> -->
            <a class="txt-color" @click="add(2, scope.row.guid)">编辑 | </a>
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="120px" :label-position="right" class="demo-ruleForm pr20">
        <el-form-item label="上传文件：" required>
          <el-upload
            class="upload-demo fl t-left"
            action="#"
            multiple
            accept="*"
            :on-exceed="handleExceed"
            :on-remove="handlePdfRemove"
            :http-request="uploadPdf"
            :file-list="fileList"
            :beforeUpload="beforeAvatarUpload"
          >
            <el-button size="mini" type="info">点击上传文件</el-button>
            <div slot="tip" class="el-upload__tip">注意：文件大小<=10M；</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="文件名称：" required>
          <el-input
            type="text"
            placeholder="请输入文件名称"
            @blur="changeFileName(ruleForm.fileName)"
            v-model="ruleForm.fileName"
            :maxlength="20"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="所属公司：" required>
          <el-select v-model="ruleForm.tenantGuid" filterable placeholder="请选择所属公司" class="fl w100f">
              <el-option 
              v-for="item in approvalerList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可见人员：" required>
          <div class="t-left">
            已选{{ ruleForm.staffGuids.length }}个人员 <a class="txt-color" @click="getOrganisation()">指定人员</a>
          </div>
        </el-form-item>
        <el-form-item label="资料描述：">
          <el-input :maxlength="200" type="textarea" :rows="5" placeholder="请填写此资料的用途，便于用户了解" v-model="ruleForm.fileDesc">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="dialogFormVisible = false">取 消</el-button>
        <el-button
          size="mini"
          type="info"
          v-if="textTitle == '发布活动'"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button size="mini" type="info" @click="submitFile()" v-else v-loading.fullscreen.lock="fullscreenLoading"
          >提 交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="选择人员" :visible.sync="visible2" width="60%" top="6%" center>
      <div>
        <div class="select-box">
          <div class="box-left fl">
            <el-input v-model="filterText" class="ipt-sty mt15" placeholder="请输入部门名称"></el-input>
            <p class="fontC-bbb">组织架构</p>
            <el-tree
              class="filter-tree"
              :data="areaData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
              ref="tree"
            >
            </el-tree>
          </div>
          <div class="box-right fr">
            <p class="fontC-bbb">选择人员<span class="clear-person" @click="clearPerson()">清空</span></p>
            <el-table
              :data="tableData1"
              @selection-change="handleSelectionChange"
              v-loading="tableLoading"
              ref="dataTable"
              :row-key="
                (row) => {
                  return row.guid;
                }
              "
              border
              height="240px"
              style="width: 100%"
            >
              <el-table-column
                type="selection"
                width="60"
                header-align="center"
                align="center"
                :reserve-selection="true"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="staffName"
                label="名称"
                width="100%"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                prop="organisationName"
                label="组织"
                width="100%"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                show-overflow-tooltip
                width=""
                prop="positionNames"
                label="岗位"
              >
              </el-table-column>
            </el-table>
            <el-pagination
              small
              class="pt pb back-color-fff t-center"
              background
              @current-change="handleCurrentChange1"
              :current-page="page1.pageIndex"
              :page-size="page1.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="page1.totalRows"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer t-right">
        <el-button plain size="mini" @click="visible2 = false">取消</el-button>
        <el-button size="mini" type="info" @click="surePerson()">确定</el-button>
        <!-- <el-button size="mini" type="info" v-else @click="upDateForm1('ruleForm')">确定</el-button> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 280,
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      input: '',
      textTitle: '',
      right: '',
      dialogFormVisible: false,
      fullscreenLoading: false,
      visible2: false,
      filterText: '',
      tableLoading: false,
      tableWrapLoading: false,
      ruleForm: {
        guid:'',
        attach: [],
        fileName: '',
        fileDesc: '',
        staffGuids: [],
        tenantGuid: '',
      },
      defaultProps: {
        id: 'guid',
        label: 'organisationName',
        children: 'children',
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantName: '',
        fileName: '',
      },
      page1: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
      },
      tableData: [],
      tableData1: [],
      approvalerList: [],
      title: '',
      areaData: [],
      fileList: [],
      multipleSelection: [],
      multipleSelection1: []
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getApprovalOrganization();
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantName: '',
        fileName: '',
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.tableWrapLoading = true;
      self.api
        .get(
          `/${serverConfig.msSalesPerformService}/resource/data/list?pageIndex=` +
            self.page.pageIndex +
            '&pageSize=' +
            self.page.pageSize +
            '&fileName=' +
            self.page.fileName +
            '&tenantName=' +
            self.page.tenantName,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableWrapLoading = false;
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //清空人员
    clearPerson(){
      let self = this;
      self.multipleSelection = [];
      self.ruleForm.staffGuids = [];
      self.$refs.dataTable.clearSelection()
    },
    //获取公司
    getApprovalOrganization() {
      let self = this;
      let query = {
        isService:true,
        tenantGuid:localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.approvalerList = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    //查询人员
    getStaff() {
      let self = this;
      self.tableLoading = true;
      self.page.totalPage = 0;
      self.page.totalRows = 0;
      self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          console.log('666',res.data)
          if(self.ruleForm.guid !== '' && res.data.data.records !== null ){
            res.data.data.records.forEach(k=>{
              this.$nextTick(() => { 
                this.$refs.dataTable.toggleRowSelection(k,false);
              })
              self.ruleForm.staffGuids.forEach(i=>{
                if(i == k.guid){
                  self.multipleSelection.push(k);
                  this.$nextTick(() => {  
                    this.$refs.dataTable.toggleRowSelection(k,true);
                  })
                }
                    
              })
            })
          }
          self.tableData1 = res.data.data.records;
          self.page1.totalPage = res.data.data.totalPages;
          self.page1.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取组织
    getOrganisation() {
      let self = this;
      self.areaData = [];
      // self.multipleSelection = [];
      self.tableData1 = [];
      if (self.ruleForm.tenantGuid == null || self.ruleForm.tenantGuid == '') {
        self.$message.error('请选择公司！');
      } else {
        self.visible2 = true;
        self.api
          .postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, {
            tenantGuid: self.ruleForm.tenantGuid,
            pageSize: '-1',
          })
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              let data = res.data.data.records;
              self.loading = false;
              if (data != null && data != '') {
                data.forEach(function (item) {
                  if (item.parentGuid == '' || item.parentGuid == null) {
                    self.areaData.push(item);
                    self.AddChildren(item, data);
                  }
                });
              }
            } else {
              self.$message.error(res.data.msg);
            }
          });
      }
    },
    //加载子节点
    AddChildren: function (item, elems) {
      for (let i = 0; i < elems.length; i++) {
        let elem = elems[i];
        if (elem.parentGuid == item.guid) {
          if (item) {
            item.children ? item.children.push(elem) : (item.children = [elem]);
          }
          this.AddChildren(elem, elems);
        }
      }
    },
    //选择人员确定
    surePerson() {
      let self = this;
      if(self.multipleSelection !== null){
        self.ruleForm.staffGuids = [];
        self.multipleSelection.forEach(item=>{
          self.ruleForm.staffGuids.push(item.guid)
        })
      }
      self.ruleForm.staffGuids = [...new Set(self.ruleForm.staffGuids)]
      // self.multipleSelection = [];
      self.visible2 = false;
    },
    handleNodeClick(data) {
      this.page.organisationGuid = data.guid;
      this.page.tenantGuid = data.tenantGuid;
      this.getStaff();
    },
    //选择表格数据
    handleSelectionChange1(val) {
      let self = this;
      self.multipleSelection1 = val;
    },
    //选择人员
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = val;
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.organisationName.indexOf(value) !== -1;
    },
    //改变文件名称
    changeFileName(val) {
      let self = this;
      console.log(self.filePdfList);
      self.fileList[0].name = val;
    },
    //上传excel
    uploadPdf(file) {
      let self = this;
      let formData = new FormData();
      formData.append('file', file.file);
      self.api.postImage(self.url, formData).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.ruleForm.attach = [];
          self.fileList = [];
          self.ruleForm.fileName = file.file.name;
          let item = {
            fileName: file.file.name,
            path: res.data.data.data,
          };
          self.ruleForm.attach.push(item);
          let item1 = {
            name: file.file.name,
            path: res.data.data.data,
          };
          self.fileList.push(item1)
          self.$message({
            message: '上传成功',
            type: 'success',
          });
        } else {
          self.filePdfList = [];
          self.$message.error('上传失败!');
        }
      }).catch(() =>{
        self.$message('上传失败！')
      })
    },
    beforeAvatarUpload(file) {                 
      var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)                
      const isLt2M = file.size / 1024 / 1024 < 10
      if(!isLt2M) {
          this.$message({
              message: '上传文件大小不能超过 10MB!',
              type: 'warning'
          });
      }
      return  isLt2M
  },
    handlePdfRemove(file) {
      let self = this;
      console.log(file.url);
      self.ruleForm.fileName = '';
      self.ruleForm.attach.forEach(function (i, index) {
        if (i.url == file.url) {
          self.ruleForm.attach.splice(index, 1);
        }
      });
      self.filePdfList.forEach(function (j, ind) {
        if (j.path == file.url) {
          self.filePdfList.splice(ind, 1);
        }
      });
    },
    beforeUpload(file) {
      // let filename = file.name;
      // let arr = filename.split('.');
      // if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
      //   this.$message.error('上传文件只能是 excel/xls 格式!');
      //   return false;
      // }
      // return arr;
    },
    handleExceed(files, fileList) {
      this.fileList = [];
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    changeFile(file, fileList) {
      let self = this;
      // let url = `/ms-logistics-trace-service/front/import/sap-stock?stockDate=${self.stockDate}&tenantGuid=${self.$store.state.guid}`;
      let formData = new FormData();
      formData.append('file', file.raw); //传文件
      self.api
        .postFile(`/${serverConfig.msAiAlgorithmService}/multiple-core/hpgc-freight?sheetNo=0`, formData)
        .then(function (res) {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message({
              type: 'success',
              message: '导入成功',
            });
            self.getUpdateData();
            self.dialogFormVisible = false;
          } else {
            self.$message({
              type: 'warning',
              message: res.data.msg,
            });
            return false;
          }
        });
    },
    downFile (row) {
      let self = this;
      window.open(JSON.parse(row.attach)[0].path);
      self.api.putNoParams(`/${serverConfig.msSalesPerformService}/resource/data/download`,row.guid).then(res=>{ 
        if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
          self.getData(true); 
        }else {
          self.$message.error(res.data.msg);
        } 
      }) 
      this.getData();
      // let blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
      // let fileName = row.fileName;
      // let objectUrl = URL.createObjectURL(blob);
      // const link = document.createElement('a')
      // link.download = fileName;
      // link.href = JSON.parse(row.attach)[0].path;
      // link.click();
    },
    //提交
    submitFile() {
      let self = this;
      if (self.ruleForm.attach == null || self.ruleForm.attach == '') {
        self.$message.error('请上传文件！');
        return;
      } else if (self.ruleForm.fileName == '') {
        self.$message.error('文件名不能为空！');
        return;
      } else if (self.ruleForm.staffGuids == null || self.ruleForm.staffGuids == '') {
        self.$message.error('请选择人员！');
        return;
      } 
      if(self.ruleForm.guid !== ''){
        self.api.put(`/${serverConfig.msSalesPerformService}/resource/data/update`, self.ruleForm).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.getData();
            this.dialogFormVisible = false;
            self.$message.success('修改成功！');
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }else{
        self.api.postJson(`/${serverConfig.msSalesPerformService}/resource/data/add`, self.ruleForm).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.getData();
            this.dialogFormVisible = false;
            self.$message.success('提交成功！');
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }
    },
    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection1.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection1 = [];
        self.multipleSelection1.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api.postJson(`/${serverConfig.msSalesPerformService}/resource/data/delete`, self.multipleSelection1).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.multipleSelection = [];
              self.$message.success('删除成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    add(type, guid) {
      let self = this;
      if (type == 1) {
        self.dialogFormVisible = true;
        self.title = '上传资料';
        self.ruleForm = {
          guid:'',
          attach: [],
          fileName: '',
          fileDesc: '',
          staffGuids: [],
          tenantGuid: '',
        }
        self.fileList = [];
        self.multipleSelection = [];
        self.$refs.dataTable.clearSelection();
      } else {
        self.title = '编辑资料';
        self.dialogFormVisible = true;
        self.ruleForm.guid = guid;
        // self.$refs.dataTable.clearSelection();
        self.fileList = [];
        self.multipleSelection = [];
        self.getEditDetail(guid);
      }
    },
    getEditDetail(guid) {
      let self = this;
      self.api
        .get(`/${serverConfig.msSalesPerformService}/resource/data/detail?guid=` + guid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.ruleForm.fileName = res.data.data.fileName;
            self.ruleForm.fileDesc = res.data.data.fileDesc;
            self.ruleForm.staffGuids = JSON.parse(res.data.data.staffGuids);
            self.ruleForm.tenantGuid = res.data.data.tenantGuid;
            let attach = JSON.parse(res.data.data.attach);
            self.ruleForm.attach = [];
            self.fileList = []
            self.ruleForm.attach = attach;
            let item = {
              name:attach[0].fileName,
              path:attach[0].path
            }
            self.fileList.push(item)
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    handleCurrentChange1(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getStaff();
    },
  },
};
</script>
